<template>
  <div class="planes-pagos-list">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :filtroNoCancelados="filtroNoCancelados"
          :incluirPlanesCancelados="incluirPlanesCancelados"
          :fechaDesdeCancelados="fechaDesdeCanceladosParam"
          :fechaHastaCancelados="fechaHastaCanceladosParam"
          :fechaDesdeTodos="fechaDesdeTodosParam"
          :fechaHastaTodos="fechaHastaTodosParam"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Planes de Pago">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="planesPagos" 
              :fields="itemFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaRegistro)="data">
              {{ data.item.fechaRegistro | fecha }}
            </template>
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(pagado)="data">
              {{ data.item.pagado ? 'Si' : 'No' }}
            </template>
            <template v-slot:cell(refinanciado)="data">
              {{ data.item.refinanciado ? 'Si' : 'No' }}
            </template>

            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Plan de Pagos</b-dropdown-item>

                <b-dropdown-item @click.stop="refinanciar(data.item)">
                  <i class="fa fa-refresh"></i>Refinanciar Plan de Pagos</b-dropdown-item>

                <b-dropdown-item @click.stop="pagarCuotas(data.item)">
                  <i class="fa fa-usd"></i>Pagar Cuotas del Plan de Pagos</b-dropdown-item>
                </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <b-modal ref="addPlanPagosModal" 
        title="Refinanciación del Plan de Pagos"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-plan-pagos
        @planPagosAgregado="planPagosRefinanciacionAgregado"
        @cancel="planPagosRefinanciacionCancelado">
      </app-plan-pagos>
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import PlanPagos from './ABMPago.vue'
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'planesPagos/getField',
  mutationType: 'planesPagos/updateField',
});

export default {
  name: 'PlanesPagos',
  components: {
    appPlanPagos: PlanPagos,
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      itemFields: [
        {
          key: 'fechaRegistro',
          label: 'Fecha',
        },
        {
          key: 'impuestoOrganismo',
          label: 'Organismo',
        },
        {
          key: 'proveedor',
          label: 'Impuesto',
        },
        {
          key: 'numero',
        },
        {
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        {
          key: 'cantidadCuotas',
          label: 'Cuotas',
          class:'text-right'
        },
        {
          key: 'importe',
          label: 'Total',
          class:'text-right'
        },
        {
          key: 'pagado',
          label: 'Cancelado',
          class:'text-center'
        },
        {
          key: 'refinanciado',
          class:'text-center'
        },
        { 
          key: 'opciones',
          label: '',
          class:'text-center'
        },
      ],
      
      planPagosId: 0,
      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'planesPagos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'filtroNoCancelados',
      'incluirPlanesCancelados',
      'fechaDesdeCancelados',
      'fechaHastaCancelados',
      'fechaDesdeTodos',
      'fechaHastaTodos',
    ]),
    fechaDesdeCanceladosParam() {
      return moment(this.fechaDesdeCancelados).format('YYYY-MM-DD');
    },
    fechaHastaCanceladosParam() {
      return moment(this.fechaHastaCancelados).format('YYYY-MM-DD');
    },
    fechaDesdeTodosParam() {
      return moment(this.fechaDesdeTodos).format('YYYY-MM-DD');
    },
    fechaHastaTodosParam() {
      return moment(this.fechaHastaTodos).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.filtroNoCancelados = filtro.filtroNoCancelados;
      this.incluirPlanesCancelados = filtro.incluirPlanesCancelados;
      this.fechaDesdeCancelados = filtro.fechaDesdeCancelados;
      this.fechaHastaCancelados = filtro.fechaHastaCancelados;
      this.fechaDesdeTodos = filtro.fechaDesdeTodos;
      this.fechaHastaTodos = filtro.fechaHastaTodos;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('planesPagos/getPlanesPagos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    consultar (item) {
      this.$router.push({ name: 'PlanPagosData', 
                          params: { id: item.id }});
    },
    editar (item) {
      this.$router.push({ name: 'PlanPagosABM', 
                          params: { id: item.id }});
    },
    refinanciar(item) {
      this.showModalConfirm('Desea refinanciar el plan de pagos seleccionado? Se cancelarán las cuotas pendientes de debitar del plan actual.', this.refinanciarPlanPagos.bind(this, item.id), 'Si', null, 'No');
    },
    refinanciarPlanPagos(planPagosId) {
      this.planPagosId = planPagosId;
      this.$refs.addPlanPagosModal.show();
    },
    planPagosRefinanciacionAgregado(planPagos){
      this.$refs.addPlanPagosModal.hide();

      planPagos.planPagosId = this.planPagosId;
      
      this.showSpinner();
      this.$store.dispatch('planesPagos/refinanciar', planPagos)
        .then(() => this.showModalMsj('El plan de pagos se refinanció con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    planPagosRefinanciacionCancelado(){
      this.$refs.addPlanPagosModal.hide();
    },
    pagarCuotas (item) {
      this.$router.push({ name: 'PagoCuotasABM', 
                          params: { id: item.id }});
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
